import { html } from 'fxjs/es';

const makePATitle = (content) =>
  G.collabo_type === '' ? html`<div class="pa-title">${content}</div>` : html`<h2>${content}</h2>`;
const makePASubTitle = (content) =>
  G.collabo_type === '' ? html`<div class="pa-sub-title">${content}</div>` : html`<h3>${content}</h3>`;
export const mpPrintGuide = () => `
<div class="print_area">
    <div class="img1">
      <img
        src="//s3.marpple.co/files/u_193535/2025/5/original/7b24c0d37bd7c6e305d1f8f773a9308b0fb7151b2.png"
        alt=""
        class="pc"
      />
      <img
        src="//s3.marpple.co/files/u_193535/2025/5/original/adf33ff4cd2451edc2d660fc10a9e9aa5cc35da11.png"
        alt=""
        class="m"
      />
    </div>
    ${makePATitle('디자인 파일 준비')}
    <ul class="list1">
      <li>마플 에디터에서 내 이미지 업로드 시 png, jpg 파일을 업로드할 수 있어요.</li>
      <li>이미지는 최소 2,500px 이상 크기로 준비하세요. (인쇄 사이즈 20cm 정도 인쇄 기준)</li>
      <li>작은 원본 이미지를 사이즈 규격에 맞게 임의로 크게 확대할 경우 인쇄 시 화질이 깨질 수 있습니다.</li>
      <li>전문 인쇄용 파일(pdf, ai, psd)이 있으신가요? 마플 에디터로 주문 완료 후, 주문자 정보(주문번호 / 성함 / 연락처)와 원본 파일을 고객센터 메일(help@marpple.com) 또는 1:1 채팅으로 보내주세요.</li>
    </ul>
    ${makePATitle('주의사항')}
    <ul class="list1">
      <li>모니터, 핸드폰에 따라 실제 인쇄 색상과 다르게 보일 수 있습니다.</li>
      <li>사진이 아닌, 드로잉 프로그램, 디자인 프로그램으로 만든 디지털용 이미지는 생각하시는 것보다 인쇄 컬러가 탁할 수 있습니다. 고객센터에서 자세한 내용을 확인해보세요.</li>
      <li>제작 시기나 환경에 따라 이전에 제작했던 상품과 동일한 파일이라도 색감차이가 있을 수 있습니다.</li>
      <li>인쇄를 원하시는 위치가 있을 경우 주문서에서 [상품 제작 요청사항]에 남겨주시거나, 1:1 상담 또는 고객센터(help@marpple.com)로 메일 주세요.</li>
      <li>상품 실측 사이즈를 반드시 확인해 주세요.</li>
    </ul>

    ${makePATitle('교환/환불 불가 사항')}
    <p class="txt1">
      마플의 모든 상품은 고객 주문에 따라 개별 제작되는 방식으로 단순 변심을 포함, 아래의 경우에는 교환 /
      환불이 불가합니다.
    </p>
    ${makePASubTitle('- 디자인 시안 색상의 차이')}
    <p class="txt2">
      프린팅 방식과 원단 재질에 따른 경우의 수가 다양하므로 인쇄 후 모니터, 혹은 종이 출력물과 색상 차이가
      발생할 수 있습니다.
    </p>
    ${makePASubTitle('- 인쇄 위치 및 크기의 차이')}
    <p class="txt2">
      제품 재질에 따른 특성의 차이와 대부분의 인쇄가 수작업으로 이루어진다는 점에서 시안과 실제 상품의 인쇄
      위치 및 크기의 오차가 발생할 수 있습니다. 인쇄 위치 및 크기를 별도로 [요청] 하지 않은 주문건에 대한 교환
      또는 환불은 불가합니다.
    </p>
    ${makePASubTitle('- 추가 주문 시 기존 상품 색상과의 컬러 차이')}
    <p class="txt2">
      상품 컬러 및 사이즈는 제작 시기별, 생산시즌별로 원단 컬러와 사이즈 차이가 발생할 수 있습니다.
    </p>
    ${makePASubTitle('- 화학 제품 사용으로 인한 손상')}
    <p class="txt2">
      우레탄 전사(PU Heat Transfer) 인쇄 제품에 솔벤트와 같은 용해력이 있는 용매를 사용한 향수를 직접적으로
      분사할 경우 인쇄 부분이 손상될 수 있으니 주의해 주세요.
    </p>

    ${makePATitle('교환/환불 기간')}
    <p class="txt1">
      물품에 문제 되는 사항에 대해서는 수령 후 7일 이내 이메일
      <a href="mailto:help@marpple.com">help@marpple.com</a> 또는 고객센터로 연락주셔야 가능합니다.
    </p>
    <p class="txt1">
      ★ 주문 완료 후 상품 및 이미지 변경을 원하실 경우 [제작준비중] 상태에서만 변경이 가능하며 [제작중]에는
      변경 및 취소가 불가합니다. 변경을 원하시는 경우 1:1 상담 및 카톡 또는 고객센터(<a href="tel:1566-9437"
        >1566-9437</a
      >)를 통해 문의 바랍니다.
    </p>
  </div>
`;
export const mpPrintGuideEn = () => html`
  <div class="print_area">
    <div class="img1">
      <img
        src="//s3.marpple.co/files/u_193535/2025/5/original/6d414d96238f5b2960bcb95f89a3e9520befbe035.png"
        alt=""
        class="pc"
      />
      <img
        src="//s3.marpple.co/files/u_193535/2025/5/original/49775da5d3ef8f1be5e9119ebcc8aa65b613540f6.png"
        alt=""
        class="m"
      />
    </div>
    ${makePATitle('Preparing Your Design File')}
    <ul class="list1">
      <li>You can upload PNG or JPG files when uploading your image in the Marpple Editor.</li>
      <li>Please prepare images with a minimum size of 2,500px. (based on approx. 20cm print size)</li>
      <li>Enlarging a small image to meet size requirements may result in poor print quality.</li>
      <li>
        Do you have a professional print file (PDF, AI, PSD)? After completing your order with the Marpple
        Editor, please send the original file along with your order information (order number / name / contact
        information) to our customer service email (help@marpple.com) or via 1:1 chat.
      </li>
    </ul>
    ${makePATitle('Important Notes')}
    <ul class="list1">
      <li>The actual print colors may differ depending on your monitor or mobile screen.</li>
      <li>
        Digital images created using drawing or design software (not photographs) may print with duller colors
        than expected. Please check with our customer support for more details.
      </li>
      <li>
        Depending on the production time or environment, there may be color differences even if the file is
        the same as the one used for previously produced items.
      </li>
      <li>
        If you have a specific print placement in mind, please leave a note in the [Production Request]
        section of your order, or contact us via 1:1 chat or email (help@marpple.com).
      </li>
      <li>Please make sure to check the actual product size before ordering.</li>
    </ul>
  </div>
`;
export const mpPrintGuideJp = () => `
<div class="print_area">
    <div class="img1">
      <img
        src="//s3.marpple.co/files/u_193535/2025/5/original/282b1626e8814d2bf29844f7eca81ff356aac5b13.png"
        alt=""
        class="pc"
      />
      <img
        src="//s3.marpple.co/files/u_193535/2025/5/original/2ea71b1126f3bc26daa62fea6f4b7e2f5aa348f94.png"
        alt=""
        class="m"
      />
    </div>
${makePATitle('デザインファイルの準備')}
    <ul class="list1">
      <li>Marppleエディターで画像をアップロードする際、PNGまたはJPGファイルが使用できます。</li>
      <li>画像は最低でも2,500px以上でご用意ください。（印刷サイズ 約20cm基準）</li>
      <li>小さな画像を無理に拡大すると、印刷時に画質が落ちる場合があります。</li>
      <li>専門の印刷用データ（PDF、AI、PSD）はお持ちですか？ マプルエディターでご注文を完了された後、注文者情報（注文番号 / お名前 / ご連絡先）と元のファイルをカスタマーサポートのメール（help@marpple.com）または1:1チャットにお送りください。</li>
    </ul>    
${makePATitle('注意事項')}
    <ul class="list1">
      <li>モニターやスマートフォンによって、実際の印刷色と異なる場合があります。</li>
      <li>写真ではなく、ドローイングやデザインソフトで作成されたデジタル画像は、思ったより印刷時の色味がくすんで見える場合があります。詳細はカスタマーサポートでご確認ください。</li>
      <li>製作時期や環境によって、以前に製作した商品と同じファイルであっても、色味に差が出る場合があります。</li>
      <li>印刷位置にご希望がある場合は、注文書の［商品製作リクエスト］欄にご記入いただくか、1:1チャットまたはカスタマーサポート（help@marpple.com）までご連絡ください。</li>
      <li>ご注文前に商品の実寸サイズを必ずご確認ください。</li>
    </ul>
    ${makePATitle('返品・交換が不可能な場合')}
    <p class="txt1">注文制作商品のため、お客様都合および以下の場合の返品・交換はいたしかねます。</p>

    ${makePASubTitle('- カラーの違い')}
    <p class="txt2">
      プリント方法や生地により、印刷後の色とモニターの色や紙へ印刷した場合の色とは違いが生じる場合がございます。予めご了承ください。
    </p>
    ${makePASubTitle('- 印刷位置および大きさの違い')}
    <p class="txt2">
      生地の特性の違いや、ほとんどの印刷を手作業で行っている関係上、モニター上での位置や大きさと実際に印刷された位置や大きさに多少違いが生じる場合がございます。ご希望の印刷位置および大きさをご要望欄にご記入いただければご指定のとおり印刷いたします。別途で指定がなかった場合は、これらの理由での交換および返品はいたしかねます。
    </p>
    ${makePASubTitle('- 追加注文時の既存商品とのカラーの違い')}
    <p class="txt2">生地のカラーおよびサイズは制作時期、生産シーズンごとに多少異なる場合がございます。</p>
    ${makePASubTitle('- 科学製品の使用による損傷')}
    <p class="txt2">
      ウレタン転写(PU Heat
      Transfer)で印刷された商品は溶解力のある成分の入った香水などを使用する場合、印刷部分が解けてしまう場合がございます。ご注意ください。
    </p>

    ${makePATitle('返品・交換が可能な期間')}
    <p class="txt1">商品に問題のある場合は、受け取り後7日以内にお問い合わせいただければご対応いたします。</p>
    <p class="txt1">
      注文完了後、商品およびイメージを変更される場合、[制作準備中]の状態でのみ変更が可能でございます。[制作中]の場合は変更およびキャンセルができませんのでご了承ください。変更をご希望の場合は1:1相談サービスおよびカスタマーセンターにお問い合わせください。
    </p>
  </div>
`;
